module.exports = __webpack_public_path__ + "npdf_icon.svg";